// SciPy details come from the pretalx API for scipy-2026 (session QVKGLW,
// state "confirmed"); no slot was assigned at the time of writing.
// ASHPC26 details come from the printed programme and abstracts in the
// conference booklet. Its event/28 page needs an Indico login, so the links
// point at the public booklet instead.
const ASHPC_BOOKLET = 'https://ashpc.eu/event/27/attachments/154/410/ASHPC26_BOOKLET.pdf';

const talks = [
  {
    title: 'Dagster-slurm: Bringing Modern Data Orchestration to Slurm-Managed',
    event: 'SciPy 2026',
    location: 'Minneapolis, USA',
    daterange: 'July 2026',
    coSpeakers: 'with Georg Heiler',
    link: 'https://pretalx.com/scipy-2026/talk/QVKGLW/',
  },
  {
    title: 'dagster-slurm: Connecting Data Orchestration to HPC Resources',
    event: 'ASHPC26, Austrian-Slovenian HPC Meeting, Technical Track',
    location: 'Vienna, Austria',
    daterange: 'April 2026',
    coSpeakers: 'with Georg Heiler',
    link: `${ASHPC_BOOKLET}#page=37`,
  },
  {
    title: 'From Laptop to Supercomputer: Reproducible ML Pipelines with dagster-slurm and metaxy',
    event: 'ASHPC26, Austrian-Slovenian HPC Meeting',
    location: 'Vienna, Austria',
    daterange: 'April 2026',
    coSpeakers: 'with Georg Heiler and Daniel Gafni, presented by Georg Heiler',
    link: `${ASHPC_BOOKLET}#page=22`,
  },
];

export default talks;
